export const translations = {
  en: {
    meta_title: "Iligan Emergency Services | Official SOS Hub",
    meta_desc: "One-tap emergency SOS broadcast and rescue coordination for Iligan City. Access police and medical assistance instantly.",
    app_title: "Iligan Emergency Services",
    status_active: "System Active",
    emergency_protocol: "EMERGENCY PROTOCOL",
    sos_desc: "One-tap emergency broadcast to trusted contacts and local authorities.",
    gps_status: "GPS Status",
    precise_coords: "Precise Coordinates",
    signal_accuracy: "Signal Accuracy",
    signal_within: "Within",
    meters: "meters",
    open_in_maps: "Open in Maps",
    trusted_contacts: "Trusted Contacts",
    comm_hub: "Communication Hub",
    wait_gps: "Waiting for secure GPS signal...",
    testing_note_title: "Testing & Development Phase",
    testing_note_desc: "This system is currently under testing and all communication channels may not work depending on location, internet access or mobile phone restrictions.",
    manage_contacts: "Manage Contacts",
    contact_name: "Contact Name",
    phone_number: "Phone Number",
    no_contacts: "No contacts found. Please add above.",
    additional_details: "Additional Details",
    emergency_note_desc: "Write additional information to help rescuers understand what you require (e.g., injured person, fire, accident).",
    emergency_note_placeholder: "Add details (e.g., 'Car breakdown', 'Need medical help')",
    broadcast_title: "Multi-Channel Broadcast",
    direct_messaging: "Direct Contact Messaging",
    data_payload_preview: "Data Payload Preview",
    copy_payload: "Copy Payload",
    copied: "Copied",
    confirm_sos: "CONFIRM SOS BROADCAST",
    cancel_broadcast: "Cancel Broadcast",
    get_location: "Getting your location...",
    access_denied: "Location access denied. Please enable GPS.",
    weather_loading: "Loading weather...",
    rescuers_info: "Available 24/7 for floods, landslides, fires, and other major calamities.",
    police_assistance: "Police Assistance",
    disaster_response: "Disaster Response",
    sos_label: "SOS",
    send_label: "SEND",
    footer_hub: "Secure Emergency Response Hub",
    visit_goiligan: "Visit goiligan.com"
  },
  ceb: {
    meta_title: "Serbisyo sa Emerhensya sa Iligan | SOS Hub",
    meta_desc: "Dali nga pagpadala og SOS sa Iligan City. Kontaka ang pulis ug CDRRMO sa usa lang ka pindot.",
    app_title: "Serbisyo sa Emerhensya sa Iligan",
    status_active: "Aktibo ang Sistema",
    emergency_protocol: "PROTOKOL SA EMERHENSYA",
    sos_desc: "Usa ka pagpindot para ipadala ang emerhensya sa mga kontak ug awtoridad.",
    gps_status: "Status sa GPS",
    precise_coords: "Tukma nga Koordinasyon",
    signal_accuracy: "Katukma sa Signal",
    signal_within: "Sulod sa",
    meters: "ka metros",
    open_in_maps: "Ablihan sa Maps",
    trusted_contacts: "Kasaligang mga Kontak",
    comm_hub: "Sentro sa Komunikasyon",
    wait_gps: "Naghulat sa signal sa GPS...",
    testing_note_title: "Hugna sa Pagsulay ug Pagpalambo",
    testing_note_desc: "Kini nga sistema gisulayan pa ug ang tanan nga agianan sa komunikasyon mahimong dili molihok depende sa lokasyon, internet, o restriction sa telepono.",
    manage_contacts: "Pagdumala sa mga Kontak",
    contact_name: "Pangalan sa Kontak",
    phone_number: "Numero sa Telepono",
    no_contacts: "Walay nakit-an nga kontak. Palihug dugangi sa taas.",
    additional_details: "Dugang Detalye",
    emergency_note_desc: "Isulat ang dugang impormasyon para mas dali mahibal-an sa mga rescuers kung unsa imong gikinahanglan (pananglitan: naay nasamdan, sunog, aksidente).",
    emergency_note_placeholder: "Butangi og detalye (e.g., 'Naguba ang sakyanan', 'Nagkinahanglan og medical nga tabang')",
    broadcast_title: "Multi-Channel nga Sibya",
    direct_messaging: "Direkta nga Pagpadala og Mensahe",
    data_payload_preview: "Preview sa Impormasyon",
    copy_payload: "Kopya sa Impormasyon",
    copied: "Nakopya na",
    confirm_sos: "KONPIRMAHA ANG SOS",
    cancel_broadcast: "Kanselahon ang Sibya",
    get_location: "Gikuha ang imong lokasyon...",
    access_denied: "Gibalibaran ang pag-access sa lokasyon. Palihug i-on ang GPS.",
    weather_loading: "Gikuha ang panahon...",
    rescuers_info: "Andam mutabang 24/7 para sa baha, landslide, sunog, ug uban pang dagkong kalamidad.",
    police_assistance: "Tabang sa Pulitika",
    disaster_response: "Tubag sa Kalamidad",
    sos_label: "TABANG",
    send_label: "IPADALA",
    footer_hub: "Sentro sa Pagtubag sa Emerhensya",
    visit_goiligan: "Bisitaha ang goiligan.com"
  }
};